import styled from 'styled-components'
import tw from 'twin.macro'

export const Container = styled.div`
  ${tw`flex flex-col h-screen`}
`

export const ChildrenContainer = styled.div`
  ${tw`flex-1`}
`
